import { filterStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryFilter";
import { tableStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryTable";
import getProp from "@insite/mobius/utilities/getProp";
import { COLORS } from "@tCentro/theme/design";
import { css } from "styled-components";

filterStyles.clearFiltersButton = {
    mergeCss: true,
    variant: "secondary",
    css: css`
        margin-right: 10px;
    `,
};

filterStyles.onlyOpenCheckbox = {
    typographyProps: {
        css: css`
            font-weight: 600;
        `,
    },
    css: css`
        span[role="checkbox"] {
            border: 2px solid #9e9d9e !important;
            border-radius: 0 !important;
            &:focus {
                box-shadow: none !important;
            }
            &[aria-checked="true"] {
                background: none !important;
                color: ${getProp("theme.typography.p.color")} !important;
                border: 2px solid ${COLORS.black} !important;
            }
        }
    `,
};

filterStyles.appliedFilterTag = {
    css: css`
        button {
            min-width: auto;
            &:hover {
                border: none !important;
                background: none !important;
            }
            &:focus {
                outline: none !important;
            }
        }
    `,
};

tableStyles.container = {
    css: css`
        overflow: auto;
        margin-top: 30px !important;
    `,
};
